import { defineMessages } from 'react-intl';

export const sharedMessages = defineMessages({
  aaChange: {
    id: 'omicsExplorer.sharedIntlLabel.aaChange',
    defaultMessage: 'AA Change',
  },
  alt: {
    id: 'omicsExplorer.sharedIntlLabel.alt',
    defaultMessage: 'Alt',
  },
  avg: {
    id: 'omicsExplorer.sharedIntlLabel.avg',
    defaultMessage: 'Mean',
  },
  ckb: {
    id: 'omicsExplorer.sharedIntlLabel.ckb',
    defaultMessage: 'CKB',
  },
  clinVarDisease: {
    id: 'omicsExplorer.sharedIntlLabel.clinVarDisease',
    defaultMessage: 'ClinVar Disease',
  },
  clinVarId: {
    id: 'omicsExplorer.sharedIntlLabel.clinVarID',
    defaultMessage: 'ClinVar ID',
  },
  clinVarNearby: {
    id: 'omicsExplorer.sharedIntlLabel.clinVarNearby',
    defaultMessage: 'ClinVar Nearby',
  },
  clinVarReview: {
    id: 'omicsExplorer.sharedIntlLabel.clinVarReview',
    defaultMessage: 'ClinVar Review',
  },
  clinVarSignificance: {
    id: 'omicsExplorer.sharedIntlLabel.clinVarSignificance',
    defaultMessage: 'ClinVar Significance',
  },
  clinVarSubmission: {
    id: 'omicsExplorer.sharedIntlLabel.clinVarSubmission',
    defaultMessage: 'ClinVar Submission',
  },
  codingEffect: {
    id: 'omicsExplorer.sharedIntlLabel.codingEffect',
    defaultMessage: 'Coding Effect',
  },
  copyNumber: {
    id: 'omicsExplorer.sharedIntlLabel.copyNumber',
    defaultMessage: 'Copy Number',
  },
  cosmicCount: {
    id: 'omicsExplorer.sharedIntlLabel.cosmicCount',
    defaultMessage: 'COSMIC Count',
  },
  cosmicHistology: {
    id: 'omicsExplorer.sharedIntlLabel.cosmicHistology',
    defaultMessage: 'COSMIC Histology',
  },
  cosmicId: {
    id: 'omicsExplorer.sharedIntlLabel.cosmicID',
    defaultMessage: 'COSMIC ID',
  },
  cosmicNearby: {
    id: 'omicsExplorer.sharedIntlLabel.cosmicNearby',
    defaultMessage: 'COSMIC Nearby',
  },
  cosmicSite: {
    id: 'omicsExplorer.sharedIntlLabel.cosmicSite',
    defaultMessage: 'COSMIC Site',
  },
  cosmicStatus: {
    id: 'omicsExplorer.sharedIntlLabel.cosmicStatus',
    defaultMessage: 'COSMIC Status',
  },
  damagingPercentage: {
    id: 'omicsExplorer.sharedIntlLabel.damagingPercentage',
    defaultMessage: 'Damaging %',
  },
  damagingRankScore: {
    id: 'omicsExplorer.sharedIntlLabel.damagingRankScore',
    defaultMessage: 'Damaging Rank Score',
  },
  dbsnpRsId: {
    id: 'omicsExplorer.sharedIntlLabel.dbsnpRsId',
    defaultMessage: 'DBSNP RS ID',
  },
  effect: {
    id: 'omicsExplorer.sharedIntlLabel.effect',
    defaultMessage: 'Effect',
  },
  empty: {
    id: 'omicsExplorer.sharedIntlLabel.empty',
    defaultMessage: '—',
  },
  exomesFreq: {
    id: 'omicsExplorer.sharedIntlLabel.exomesFreq',
    defaultMessage: 'Exomes Freq',
  },
  exomesHom: {
    id: 'omicsExplorer.sharedIntlLabel.exomesHom',
    defaultMessage: 'Exomes HOM',
  },
  exonNumber: {
    id: 'omicsExplorer.sharedIntlLabel.exonNumber',
    defaultMessage: 'EXON Number',
  },
  expression: {
    id: 'omicsExplorer.sharedIntlLabel.expression',
    defaultMessage: 'Expression',
  },
  fathmm: {
    id: 'omicsExplorer.sharedIntlLabel.fathmm',
    defaultMessage: 'FATHMM',
  },
  gene: {
    id: 'omicsExplorer.sharedIntlLabel.gene',
    defaultMessage: 'Gene',
  },
  gene1AndGene2: {
    id: 'omicsExplorer.summary.gene1AndGene2',
    defaultMessage: '{gene1}-{gene2}',
  },
  geneClass: {
    id: 'omicsExplorer.sharedIntlLabel.geneClass',
    defaultMessage: 'Gene Class',
  },
  geneId: {
    id: 'omicsExplorer.sharedIntlLabel.geneId',
    defaultMessage: 'Gene ID',
  },
  genomesFreq: {
    id: 'omicsExplorer.sharedIntlLabel.genomesFreq',
    defaultMessage: 'Genomes Freq',
  },
  genomesHom: {
    id: 'omicsExplorer.sharedIntlLabel.genomesHom',
    defaultMessage: 'Genomes HOM',
  },
  germline: {
    id: 'omicsExplorer.sharedIntlLabel.germline',
    defaultMessage: 'Germline',
  },
  germlineShort: {
    id: 'omicsExplorer.sharedIntlLabel.germlineShort',
    defaultMessage: 'Germline Short',
  },
  germlineStructural: {
    id: 'omicsExplorer.sharedIntlLabel.germlineStructural',
    defaultMessage: 'Germline Structural',
  },
  germlineCopyNumber: {
    id: 'omicsExplorer.sharedIntlLabel.germlineCopyNumber',
    defaultMessage: 'Germline Copy Number',
  },
  germlineExpression: {
    id: 'omicsExplorer.sharedIntlLabel.germlineExpression',
    defaultMessage: 'Germline Expression',
  },
  heterozygous: {
    id: 'omicsExplorer.sharedIntlLabel.heterozygous',
    defaultMessage: 'HET',
  },
  heterozygousReference: {
    id: 'omicsExplorer.sharedIntlLabel.heterozygousReference',
    defaultMessage: 'REF',
  },
  homozygous: {
    id: 'omicsExplorer.sharedIntlLabel.homozygous',
    defaultMessage: 'HOM',
  },
  igv: {
    id: 'omicsExplorer.sharedIntlLabel.igv',
    defaultMessage: 'IGV',
  },
  jax: {
    id: 'omicsExplorer.sharedIntlLabel.jax',
    defaultMessage: 'JAX',
  },
  viewIgv: {
    id: 'omicsExplorer.sharedIntlLabel.viewIgv',
    defaultMessage: 'View IGV',
  },
  impact: {
    id: 'omicsExplorer.sharedIntlLabel.impact',
    defaultMessage: 'Impact',
  },
  inFrame: {
    id: 'omicsExplorer.sharedIntlLabel.inFrame',
    defaultMessage: 'In Frame',
  },
  labReportedSignificance: {
    id: 'omicsExplorer.sharedIntlLabel.labReportedSignificance',
    defaultMessage: 'Lab Reported Significance',
  },
  max: {
    id: 'omicsExplorer.sharedIntlLabel.max',
    defaultMessage: 'Maximum',
  },
  maxFreq: {
    id: 'omicsExplorer.sharedIntlLabel.maxFreq',
    defaultMessage: 'Max Freq',
  },
  median: {
    id: 'omicsExplorer.sharedIntlLabel.median',
    defaultMessage: 'Median',
  },
  min: {
    id: 'omicsExplorer.sharedIntlLabel.min',
    defaultMessage: 'Minimum',
  },
  minFreq: {
    id: 'omicsExplorer.sharedIntlLabel.minFreq',
    defaultMessage: 'Min Freq',
  },
  mutTaster: {
    id: 'omicsExplorer.sharedIntlLabel.mutTaster',
    defaultMessage: 'MUT Taster',
  },
  nnChange: {
    id: 'omicsExplorer.sharedIntlLabel.nnChange',
    defaultMessage: 'NC Change',
  },
  position: {
    id: 'omicsExplorer.sharedIntlLabel.position',
    defaultMessage: 'Position',
  },
  proteinEffect: {
    id: 'omicsExplorer.sharedIntlLabel.proteinEffect',
    defaultMessage: 'Protein Effect',
  },
  q1: {
    id: 'omicsExplorer.sharedIntlLabel.q1',
    defaultMessage: 'Q1',
  },
  q3: {
    id: 'omicsExplorer.sharedIntlLabel.q3',
    defaultMessage: 'Q3',
  },
  ref: {
    id: 'omicsExplorer.sharedIntlLabel.ref',
    defaultMessage: 'Ref',
  },
  refAltDepth: {
    id: 'omicsExplorer.sharedIntlLabel.refAltDepth',
    defaultMessage: 'Ref:Alt:Depth',
  },
  selectVariant: {
    id: 'omicsExplorer.sharedIntLabel.selectVariant',
    defaultMessage: 'Add to Report',
  },
  sift: {
    id: 'omicsExplorer.sharedIntlLabel.sift',
    defaultMessage: 'Sift',
  },
  somatic: {
    id: 'omicsExplorer.sharedIntlLabel.somatic',
    defaultMessage: 'Somatic',
  },
  somaticShort: {
    id: 'omicsExplorer.sharedIntlLabel.somaticShort',
    defaultMessage: 'Somatic Short',
  },
  somaticStructural: {
    id: 'omicsExplorer.sharedIntlLabel.somaticStructural',
    defaultMessage: 'Somatic Structural',
  },
  somaticCopyNumber: {
    id: 'omicsExplorer.sharedIntlLabel.somaticCopyNumber',
    defaultMessage: 'Somatic Copy Number',
  },
  somaticExpression: {
    id: 'omicsExplorer.sharedIntlLabel.somaticExpression',
    defaultMessage: 'Somatic Expression',
  },
  stddev: {
    id: 'omicsExplorer.sharedIntlLabel.stddev',
    defaultMessage: 'Std Deviation',
  },
  transcriptId: {
    id: 'omicsExplorer.sharedIntlLabel.transcriptID',
    defaultMessage: 'Transcript ID',
  },
  variantAlleleFreq: {
    id: 'omicsExplorer.sharedIntlLabel.variantAlleleFreq',
    defaultMessage: 'Variant Allele Freq',
  },
  variantClass: {
    id: 'omicsExplorer.sharedIntlLabel.variantClass',
    defaultMessage: 'Variant Class',
  },
  vcfFilter: {
    id: 'omicsExplorer.sharedIntlLabel.vcfFilter',
    defaultMessage: 'VCF Filter',
  },
  vcfQual: {
    id: 'omicsExplorer.sharedIntlLabel.vcfQual',
    defaultMessage: 'VCF Qual',
  },
  zygosity: {
    id: 'omicsExplorer.sharedIntlLabel.zygosity',
    defaultMessage: 'Zygosity',
  },
});
